const pad = (value) => String(value).padStart(2, "0")

export const formatDateParam = (date) => {
  if (!date) return ""
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
}

export const getDatePresetRange = (preset) => {
  const today = new Date()
  const start = new Date(today)
  const end = new Date(today)

  if (preset === "today") {
    return {
      startDate: formatDateParam(start),
      endDate: formatDateParam(end),
    }
  }

  if (preset === "yesterday") {
    start.setDate(start.getDate() - 1)
    end.setDate(end.getDate() - 1)
    return {
      startDate: formatDateParam(start),
      endDate: formatDateParam(end),
    }
  }

  if (preset === "week") {
    const day = start.getDay()
    const diff = day === 0 ? 6 : day - 1
    start.setDate(start.getDate() - diff)
    return {
      startDate: formatDateParam(start),
      endDate: formatDateParam(end),
    }
  }

  if (preset === "month") {
    start.setDate(1)
    return {
      startDate: formatDateParam(start),
      endDate: formatDateParam(end),
    }
  }

  if (preset === "year") {
    start.setMonth(0, 1)
    return {
      startDate: formatDateParam(start),
      endDate: formatDateParam(end),
    }
  }

  return {
    startDate: "",
    endDate: "",
  }
}

export const getDateFilterParams = (dateFilter, fieldName) => {
  if (!dateFilter?.startDate && !dateFilter?.endDate) return {}

  return {
    ...(dateFilter.startDate ? { [`${fieldName}__gte`]: `${dateFilter.startDate}T00:00:00` } : {}),
    ...(dateFilter.endDate ? { [`${fieldName}__lte`]: `${dateFilter.endDate}T23:59:59` } : {}),
  }
}
